import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import ViewMenuButton from './ViewMenuButton'
import { mobileHero, hero, heroText, awardLogo, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          w="100%"
          boxShadow="1px 1px 3px rgba(0,0,0,.6)"
          image={`url(${mobileHero}) top / cover no-repeat`}
          pv="15px"
          column
          justifyBetween
          alignCenter
          textCenter
        >
          <CFImage
            w="58%"
            maxWidth="350px"
            src={mobileHeroText}
            alt="Hana Sushi Chilliwack hero text"
            zIndex={98}
          />
          <CFView column center>
            <a href="">
              <CFImage
                mv="15px"
                width="100%"
                maxWidth="90px"
                src="https://threebestrated.ca/awards/sushi-chilliwack-2024-drk.svg"
                alt="Best Sushi in Chilliwack"
              />
              <CFImage
                mv="15px"
                width="100%"
                maxWidth="90px"
                src="https://threebestrated.ca/awards/sushi-chilliwack-2025-drk.svg"
                alt="Best Sushi in Chilliwack"
              />
              <CFImage
                mv="15px"
                width="100%"
                maxWidth="90px"
                src="https://threebestrated.ca/awards/sushi-chilliwack-2026-drk.svg"
                alt="Best Sushi in Chilliwack"
              />
            </a>
            <CFView mb="10px" pulsate>
              <OrderPickupButton />
            </CFView>
            <ViewMenuButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          w="100%"
          h="100vh"
          maxHeight="650px"
          maxWidth="1400px"
          zIndex={90}
          image={`url(${hero}) center / cover no-repeat`}
          column
          justifyBetween
          textCenter
        >
          <Header />
          <CFView column center h="600px">
            <CFImage
              w="70%"
              maxWidth="800px"
              src={heroText}
              alt="Hana Sushi Chilliwack hero text"
              zIndex={98}
            />
            <CFView mv="15px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
